import { render, staticRenderFns } from "./AddInstanceDialog.vue?vue&type=template&id=64a627ae&"
import script from "./AddInstanceDialog.vue?vue&type=script&lang=ts&"
export * from "./AddInstanceDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports